import { Component, OnInit } from '@angular/core'
import { AuthService } from '../../core/services/auth/auth.service'
import { MatDialog } from '@angular/material/dialog'
import {
  PagedContactTypeResponse,
  SearchContactTypeModel,
} from '../../core/models/contact-type.model'
import { MatCard } from '@angular/material/card'
import { MatProgressBar } from '@angular/material/progress-bar'
import { PaginationComponent } from '../../shared/components/pagination/pagination.component'
import { TableListComponent } from '../../shared/components/table-list/table-list.component'
import { ServiceOrderService } from '../../core/services/service/service-order/service-order.service'
import { ContractCreateComponent } from '../../features/contract/contract-create/contract-create.component'
import { ProposalClientService } from '../../core/services/proposal/proposal-client/proposal-client.service'
import { ContractClientService } from '../../core/services/contract/contract-client/contract-client.service'
import { ScheduleFleetService } from '../../core/services/schedule/schedule-fleet/schedule-fleet.service'
import { ScheduleComponent } from '../../features/schedule/schedule.component'
import { ScheduleSearchComponent } from "./schedule-search/schedule-search.component";
import { FormGroup } from '@angular/forms'
import { TableListFixedComponent } from "../../shared/components/table-list-fixed/table-list-fixed.component";
import { interval } from 'rxjs'
import { MatPaginatorModule, PageEvent } from "@angular/material/paginator";
import { TableListScheduleFleetComponent } from "../../shared/components/table-list-schedule-fleet/table-list-schedule-fleet.component";

@Component({
  selector: 'contract',
  imports: [
    MatCard,
    MatProgressBar,
    PaginationComponent,
    TableListComponent,
    ScheduleSearchComponent,
    TableListFixedComponent,
    MatPaginatorModule,
    TableListScheduleFleetComponent
  ],
  templateUrl: './fleet-schedule.component.html',
  styleUrl: './fleet-schedule.component.scss',
  providers: [ServiceOrderService, AuthService],
  standalone: true,
})
export class FleetScheduleComponent implements OnInit {

  constructor(
    private proposalClientService: ProposalClientService,
    private contractClientService: ContractClientService,
    private scheduleFleetService: ScheduleFleetService,
    private authService: AuthService,
    private dialog: MatDialog,

  ) { }

  form!: FormGroup;
  page = 1
  rows = 10
  numberRows = 0
  itemsList: any[] = []
  loading = false
  searchForm: SearchContactTypeModel = new SearchContactTypeModel()
  inputSearch = ''

  columns: any[] = [
    // { keyColumn: 'code', key: 'id', description: 'Código' },
    {
      keyColumn: 'os_period_date',
      key: 'os_period_date',
      description: 'Datas',
    },
    {
      keyColumn: 'os_code',
      key: 'os_code',
      description: 'Códigos',
    },
    {
      keyColumn: 'os_client',
      key: 'os_client',
      description: 'Clientes',
    },
    {
      keyColumn: 'os_percusent',
      key: 'os_percusent',
      description: 'Percurso',
    },
    {
      keyColumn: 'os_services',
      key: 'os_services',
      description: 'Serviço',
    },
    {
      keyColumn: 'os_vehicles',
      key: 'os_vehicles',
      description: 'Veículo',
    },
    {
      keyColumn: 'os_driver',
      key: 'os_driver',
      description: 'Motorista',
    },
    {
      keyColumn: 'nomeEvento',
      key: 'nomeEvento',
      description: 'Evento',
    },
    {
      keyColumn: 'status',
      key: 'descricaoStatus',
      description: 'Status',
    },
    {
      keyColumn: 'action',
      key: { edit: true, delete: false, view: true },
      description: 'Ações',
      stickerEnd: true,
      width: '100px'
    },
  ]

  screen = 'status cotação'

  ngOnInit() {
    this.checkColumnAction()
    this.searchFleet(this.createModel())
    // this.getListItems()
    interval(3600000).subscribe(() => {
      this.searchFleet(this.createModel())
    })
  }

  checkColumnAction() {
    const index = this.columns.findIndex((ele: any) => {
      return ele.keyColumn == 'action'
    })
    if (index != -1) {
      this.columns[index].key = {
        //edit: this.checkPermission('editar'),
        delete: this.checkPermission('deletar'),
        edit: true,
        view: true,
      }
      if (!Object.values(this.columns[index].key).includes(true)) {
        this.columns.splice(index, 1)
      }
    }
  }

  checkPermission(permission: string) {
    return this.authService.checkPermission(permission, this.screen)
  }

  searchFleet(data: any) {
    this.loading = true
    this.scheduleFleetService.searchPagedAgendaFrota(this.page, this.rows, data).subscribe({
      next: (res) => {
        this.treatResponse(res)
        this.loading = false
      },
      error: (err) => {
        this.loading = false
      }
    })
  }

  createModel() {


    return {

      dataInicio: '',
      dataFinal: '',
      nomeCliente: '',
      nomeSubCliente: '',
      status: 4,
      descricaoOrigem: '',
      descricaoDestino: '',
      descricaoTipoServico: '',
      servico: '',
      descricaoTipoVeiculo: '',
      descricaoTipoMotorista: '',
      codigoTg: '',
      codigoOs: '',
    }
  }

  search(event: any) {
    const search = event
    this.page = 1
    if (search) {
      this.searchForm.descricao = search
      this.searchListItems()
    } else {
      this.getListItems()
    }
  }

  pageChanged(page: number) {
    this.page = page
    this.uploadList()
  }

  uploadList(type = '') {
    if (type == 'new') {
      this.searchForm = new SearchContactTypeModel()
    }
    if (this.searchForm.descricao) {
      this.searchListItems()
    } else {
      this.getListItems()
    }
  }

  onPageEvent(event: PageEvent) {
    this.page = event.pageIndex + 1
    this.rows = event.pageSize
    this.uploadList()
  }

  listSearch(event: any) {
    this.loading = true
    if (event == null) {
      this.loading = false
      this.itemsList = []
      this.numberRows = 0
      this.loading = false

    } else if (event === 'reset') {

      this.searchFleet(this.createModel())

    } else if (event && event !== 'reset') {
      this.searchFleet(event)
    } else {

      this.itemsList = event
      this.numberRows = event.length
      this.loading = false
    }
    //time para aguardar o retorno da api

  }



  treatResponse(response: any) {
    const list = []
    if (response.data) {


      for (const item of response.data) {
        list.push(item)
      }

    }
    this.itemsList = list
    this.numberRows = response.totalItens
  }

  getListItems() {
    this.loading = true
    this.scheduleFleetService
      .listPagedAgendaFrota(this.page, this.rows)
      .subscribe({
        next: (response: any) => {
          this.treatResponse(response)
        },
        error: (err: PagedContactTypeResponse) => { },
        complete: () => {
          this.loading = false
        },
      })
  }

  searchListItems() {
    this.loading = true
    this.scheduleFleetService
      .listPagedAgendaFrota(this.page, this.rows)
      .subscribe({
        next: (response: any) => {
          this.treatResponse(response)
        },
        error: (err: PagedContactTypeResponse) => { },
        complete: () => {
          this.loading = false
        },
      })
  }

  newPriceQuote() {
    const dialogRef = this.dialog.open(ContractCreateComponent, {
      enterAnimationDuration: '100ms',
      exitAnimationDuration: '100ms',
      maxWidth: '100vw',
      width: '100vw',
      maxHeight: '100vh',
      height: '100vh',
      panelClass: 'dialog-fullscreen',
    })
    dialogRef.componentInstance.responseEdit.subscribe((response) => {
      if (response) {
        this.uploadList()
      }
    })
  }

  editItem(item: any) {
    const dialogRef = this.dialog.open(ScheduleComponent, {
      enterAnimationDuration: '100ms',
      exitAnimationDuration: '100ms',
      maxWidth: '100vw',
      width: '100vw',
      maxHeight: '100vh',
      height: '100vh',
      panelClass: 'dialog-fullscreen',
      data: { item, viewMode: false }
    })
    dialogRef.componentInstance.responseEdit.subscribe((response: any) => {
      if (response) {

        this.searchFleet(this.createModel())
      }
    })
    dialogRef.afterClosed().subscribe((response) => {
      if (response) {

        this.searchFleet(this.createModel())

      }
    })
  }

  viewItem(item: any) {
    const dialogRef = this.dialog.open(ScheduleComponent, {
      enterAnimationDuration: '100ms',
      exitAnimationDuration: '100ms',
      maxWidth: '100vw',
      width: '100vw',
      maxHeight: '100vh',
      height: '100vh',
      panelClass: 'dialog-fullscreen',
      data: { item, viewMode: true }


    })
    // dialogRef.componentInstance.responseViewEdit.subscribe((response: any) => {
    //   if (response) {
    //     this.searchFleet()
    //   }
    // })
    // dialogRef.afterClosed().subscribe(() => {
    //   this.searchFleet()
    // })
  }

  // downloadItem(item: any) {
  //   this.contractClientService.downloadContractClient(item.id).subscribe({
  //     next: (response: any) => {
  //       downloadBase64File(
  //         response.data.fileContent,
  //         response.data.fileName,
  //         response.data.type,
  //       )
  //     },
  //     error: (err: ResponseRequestModel) => {
  //       console.error(err)
  //     },
  //     complete: () => { },
  //   })
  // }

  deleteItem(item: any) {
  }

}
